
export const apiError = (type, value) => {
  return dispatch => {
    dispatch({ type: 'SET_API_ERROR', data: {
      type,
      value
    }})
  }
}
